import { kebabCaseToLabel } from '../../utils';
import SidebarButton, { SidebarButtonProps } from './SidebarButton';

export type SidebarItem = Omit<SidebarButtonProps, 'active' | 'label' | 'startElement' | 'subLabel' | 'onClick'> & {
  id: string;
  active: boolean;
  onClick: () => void;
};

interface SidebarButtonGroupProps {
  items: SidebarItem[];
}

const SidebarButtonGroup = ({ items }: SidebarButtonGroupProps) => {
  return (
    <div className="flex w-full flex-col gap-2">
      {items.map((item) => (
        <SidebarButton key={item.id} label={kebabCaseToLabel(item.id)} {...item} />
      ))}
    </div>
  );
};

export default SidebarButtonGroup;
